import React from 'react';
import './FeatureBar.css';

function FeatureBar() {
  return (
    <section className="feature-bar">
      <div className="feature-item">
        <div className="feature-icon">
          {/* Icône Paiement Sécurisé */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-3zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V13H5V6.3l7-3.11v9.8z"/></svg>
        </div>
        <div className="feature-text">
          <h4>Paiement Sécurisé</h4>
          <p>Transactions 100% protégées et confidentielles.</p>
        </div>
      </div>

      <div className="feature-item">
        <div className="feature-icon">
          {/* Icône Livraison Rapide */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zM18 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>
        </div>
        <div className="feature-text">
          <h4>Livraison Rapide</h4>
          <p>Expédition soignée sous 48h en France métropolitaine.</p>
        </div>
      </div>

      <div className="feature-item">
        <div className="feature-icon">
          {/* Icône Certificat d'Authenticité */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10l4 4v2h4zM18 12H4v8h14v-8zm-8 6H6v-2h4v2zm4 0h-2v-2h2v2zm0-4h-6v-2h6v2z"/></svg>
        </div>
        <div className="feature-text">
          <h4>Certificat d'Authenticité</h4>
          <p>Chaque perle de Tahiti est livrée avec son certificat.</p>
        </div>
      </div>
      
      <div className="feature-item">
        <div className="feature-icon">
          {/* Icône Service Client */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-12H9v2h2v2H9v2h2v2H9v2h4v-2h-2v-2h2v-2h-2V8h2V6zm4 6h-2v2h2v-2zm0-4h-2v2h2V8z"/></svg>
        </div>
        <div className="feature-text">
          <h4>Service Client</h4>
          <p>À votre écoute par téléphone ou par email.</p>
        </div>
      </div>
    </section>
  );
}

export default FeatureBar;